module.exports = __webpack_public_path__ + "img/notification-active.f871ea5b.svg";